// @flow
import * as React from 'react';
import type { SyntheticEvent } from 'react'; // <-- add this import

import { useState } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { useTheme } from '@mui/material/styles';

import removableModalImageStyles from './Styles/RemovableModalImage.Style';
import { createClasses } from '../../utils/stylesUtils';

type Props = {
  src: string,
  alt?: string,
  onRemove: (event: SyntheticEvent<>) => void,
  onError?: () => void,
  isRemovable?: boolean
};

const RemovableModalImage = (props: Props) => {
  const {
    src,
    alt = '',
    onRemove,
    onError,
    isRemovable = true
  } = props;
  const theme = useTheme();
  const classes = createClasses(removableModalImageStyles, theme);
  const [openModal, setOpenModal] = useState(false);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <Box sx={classes.container}>
      <Box sx={{ position: 'relative', display: 'inline-block' }}>
        <img
          src={src}
          alt={alt}
          style={classes.image}
          onClick={() => setOpenModal(true)}
          onError={onError}
        />
        {isRemovable && (
          <IconButton
            onClick={onRemove}
            sx={{
              ...classes.removeButton,
              color: 'white',
              padding: '4px',
              '& .MuiSvgIcon-root': {
                fontSize: '1.2rem'
              }
            }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        )}
      </Box>
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="lg"
        PaperProps={{
          sx: {
            position: 'relative',
            maxWidth: '90vw',
            maxHeight: '90vh',
            m: 2
          }
        }}
      >
        <IconButton
          onClick={handleCloseModal}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            backgroundColor: 'rgba(0,0,0,0.5)',
            color: 'white',
            zIndex: 1,
            '&:hover': {
              backgroundColor: 'rgba(0,0,0,0.7)'
            }
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ p: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img
            src={src}
            alt={alt}
            style={{ maxWidth: '100%', maxHeight: '85vh', objectFit: 'contain' }}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default RemovableModalImage;